/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var StackHDownIcon16Solid = forwardRef('StackHDownIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.5.95a.55.55 0 1 0 0 1.1h5a.55.55 0 1 0 0-1.1h-5Z" }),
        React.createElement("path", { d: "M2.95 3.5a.55.55 0 0 1 .55-.55h9a.55.55 0 1 1 0 1.1h-9a.55.55 0 0 1-.55-.55Z" }),
        React.createElement("path", { d: "M1 7.5A2.5 2.5 0 0 1 3.5 5h9A2.5 2.5 0 0 1 15 7.5v5a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 1 12.5v-5Z" })));
});
